// Quick search
$(function() {
  const quickSearchResults = $("#quick-search__results");
  const quickSearchNoResults = $("#quick-search__no-results");
  const quickSearchError = $("#quick-search__error");
  const quickSearchLoading = $("#quick-search__loading");

  // Exit early if elements don't exist
  if (!quickSearchResults.length) return;

  // Track if we've successfully loaded results at least once
  let hasLoadedResults = false;
  let isLoadingMore = false;
  let hasMoreResults = true;

  // Use addClass/removeClass since Tailwind's .hidden uses !important
  const hideAll = () => {
    quickSearchLoading.addClass('hidden');
    quickSearchResults.addClass('hidden');
    quickSearchNoResults.addClass('hidden');
    quickSearchError.addClass('hidden');
  };

  const showError = () => {
    // Don't show error if we haven't loaded results yet and skeleton is showing
    if (!hasLoadedResults && !quickSearchLoading.hasClass('hidden')) {
      return;
    }
    hideAll();
    quickSearchError.removeClass('hidden');
  };

  const showLoading = () => {
    // If skeleton is already visible, don't hide/show it (prevents flash)
    if (!quickSearchLoading.hasClass('hidden')) {
      // Just hide other states
      quickSearchResults.addClass('hidden');
      quickSearchNoResults.addClass('hidden');
      quickSearchError.addClass('hidden');
      return;
    }
    hideAll();
    quickSearchLoading.removeClass('hidden');
  };

  const showNoResults = () => {
    hasLoadedResults = true;
    hideAll();
    quickSearchNoResults.removeClass('hidden');
  };

  const refreshCarousel = () => {
    quickSearchResults[0]?.dispatchEvent(new CustomEvent('carousel:refresh', { bubbles: true }));
  };

  const showResults = (html) => {
    hasLoadedResults = true;
    hideAll();
    const track = quickSearchResults.find('[x-ref="track"]');
    if (track.length) {
      track.html(html);
    } else {
      quickSearchResults.html(html);
    }
    quickSearchResults.removeClass('hidden');
    window.LucideIcons?.initialize(quickSearchResults[0]);
    requestAnimationFrame(refreshCarousel);
  };

  const appendResults = (html) => {
    const track = quickSearchResults.find('[x-ref="track"]');
    if (track.length) {
      track.append(html);
    }
    window.LucideIcons?.initialize(quickSearchResults[0]);
    requestAnimationFrame(refreshCarousel);
  };

  const doQuickSearch = (onLoad) => {
    showLoading();
    hasMoreResults = true;

    // Clear any existing timers
    if (window.quickSearchTimer) {
      clearTimeout(window.quickSearchTimer);
    }

    // Set a timeout to show the error message if the request takes too long
    window.quickSearchTimer = setTimeout(showError, 5000);

    $.ajax({
      url: "/app/async/qsearch?" + $("#quick-search__form").serialize(),
      timeout: 10000,
      success: function(response) {
        clearTimeout(window.quickSearchTimer);

        if (typeof onLoad === "function") {
          onLoad();
        }

        // Check if response contains error indicators (case-insensitive)
        // Note: avoid matching "error" alone as it matches "onerror" attributes in HTML
        const lowerResponse = (response || "").toLowerCase();
        if (lowerResponse.includes("temporarily unavailable") ||
            lowerResponse.includes("not logged in")) {
          showError();
        } else if ($.trim(response) === "") {
          showNoResults();
        } else {
          showResults(response);
        }
      },
      error: function() {
        clearTimeout(window.quickSearchTimer);
        showError();
      }
    });
  };

  const loadMore = () => {
    if (isLoadingMore || !hasMoreResults || !hasLoadedResults) return;
    isLoadingMore = true;

    $.ajax({
      url: "/app/async/qsearch?" + $("#quick-search__form").serialize(),
      timeout: 10000,
      success: function(response) {
        isLoadingMore = false;
        if (!response || $.trim(response) === "" ||
            response.toLowerCase().includes("temporarily unavailable")) {
          hasMoreResults = false;
          return;
        }
        appendResults(response);
      },
      error: function() {
        isLoadingMore = false;
        hasMoreResults = false;
      }
    });
  };

  // Monitor scroll position on the track for infinite loading
  const setupInfiniteScroll = () => {
    const observer = new MutationObserver(() => {
      const track = quickSearchResults.find('[x-ref="track"]')[0];
      if (track && !track._scrollBound) {
        track._scrollBound = true;
        track.addEventListener('scroll', () => {
          const remaining = track.scrollWidth - track.scrollLeft - track.clientWidth;
          if (remaining < track.clientWidth * 0.5) {
            loadMore();
          }
        }, { passive: true });
      }
    });
    observer.observe(quickSearchResults[0], { childList: true, subtree: true });
  };
  setupInfiniteScroll();

  // Refresh whenever any of the quick-search form inputs change
  // Note: Initial fetch is triggered by Alpine's quickSearchFilters.init() via triggerChange()
  $("#quick-search__form input, #quick-search__form select").change(doQuickSearch);
  $("#quick-search__form").submit(function(e) {
    e.preventDefault();
    doQuickSearch();
  });
});
